import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'svgxuse'; // fixes IE10/11 issue when using external SVG
import React from 'react';
import ReactDOM from 'react-dom';
import './scss/style.scss';
import './scss/global/_fonts.scss';
// import 'babel-polyfill';
import 'number-to-locale-string';
import {Router, getSiteMap} from './js/lib/Router';
import {consumeMaintenanceBypassToken, stripMaintenanceBypassParam} from './js/lib/maintenanceUtils';

/**
 * Maintenance mode: grant or revoke the QA bypass before the app mounts, so the
 * token never reaches the router, analytics or browser history.
 */
if (consumeMaintenanceBypassToken()) {
    console.info('** [maintenance] bypass active - this session is not seeing the customer experience');
}
stripMaintenanceBypassParam();

/**
 * ReactDOM: render app
 */
ReactDOM.render(getSiteMap(Router), document.getElementById('app'));
